import { Component, input, output } from '@angular/core';
import { FormArray, type FormControl, type FormGroup } from '@angular/forms';

import { DividerComponent } from '@core/user-interface-legacy';
import type { DynamicFormConfig } from '@tellent-ask-hr/dynamic-forms-types';

import { DefineFormWrapperComponent } from '../../partials/define-form-wrapper/define-form-wrapper.component';
import { SingleInputComponent } from '../../partials/single-input/single-input.component';
import { SortableOptionsComponent } from '../../partials/sortable-options/sortable-options.component';

@Component({
  selector: 'rt-question-with-options',
  imports: [
    DefineFormWrapperComponent,
    SingleInputComponent,
    SortableOptionsComponent,
    DividerComponent,
  ],
  template: `
    <rt-define-form-wrapper
      [defineForm]="defineForm()"
      [respondKindIcon]="defineConfig().icon"
      [respondKindName]="defineConfig().name"
      (duplicate)="duplicate.emit()"
      (delete)="delete.emit()"
      (changeTemplate)="changeTemplate.emit($event)"
    >
      <rt-simple-question padding-medium [defineForm]="defineForm()" />
      <rt-divider />
      <rt-question-options [defineForm]="defineForm()" />
    </rt-define-form-wrapper>
  `,
})
export class QuestionWithOptionsComponent {
  public defineConfig = input.required<DynamicFormConfig['defineConfig']>();
  public defineForm = input.required<
    FormGroup<{
      question: FormControl<string>;
      hint: FormControl<string>;
      required: FormControl<boolean>;
      options: FormArray<FormGroup<{ value: FormControl<string> }>>;
    }>
  >();

  public duplicate = output();
  public delete = output();
  public changeTemplate = output<string>();
}
